import { Skeleton } from "@stacklet/ui";

import { BackdropFallback } from "./BackdropFallback";

interface Props {
  height?: string;
  width?: string;
}

export function DialogFallback({ height = "90vh", width = "600px" }: Props) {
  return (
    <BackdropFallback>
      <Skeleton height={height} variant="rectangular" width={width} />
    </BackdropFallback>
  );
}
